import type { SrsCard } from "../state/profile";

/** A card counts as "mastered" once spaced repetition has pushed its
    interval past three weeks — shared between plaques.ts (Phase 3) and
    srs.ts/session.ts (Phase 4) so both agree on the same threshold. */
export const MASTERY_INTERVAL_DAYS = 21;

export function isMastered(card: SrsCard | undefined): boolean {
  return !!card && card.interval >= MASTERY_INTERVAL_DAYS;
}
